import config from '../../config';

export default class AlertService {
  constructor($rootScope, $sce, $timeout, $sanitize) {
    'ngInject';

    Object.assign(this, { $rootScope, $sce, $timeout, $sanitize });
    this.$rootScope.alerts = [];
  }

  getDelay(alertType) {
    return alertType in config.ALERTS_AUTO_CLOSE
      ? config.ALERTS_AUTO_CLOSE[alertType]
      : config.ALERTS_AUTO_CLOSE.default;
  }

  add(msg = '', errorCode = null, type = 'danger', customDelay = null) {
    return new Promise((resolve) => {
      const alert = this._createAlert(msg, errorCode, type, resolve);
      if (!this.$rootScope.alerts.find((a) => a.msg.toString() === alert.msg.toString())) {
        this.$rootScope.alerts.push(alert);
      }

      if (config.ALERTS_AUTO_CLOSE) {
        const delay = customDelay || this.getDelay(type);
        if (delay) {
          this.setAutoClose(alert, resolve, delay);
        }
      }
    });
  }

  success(msg = '', code = null, customDelay = null) {
    return this.add(msg, code, 'success', customDelay);
  }

  warning(msg = '', code = null, customDelay = null) {
    return this.add(msg, code, 'warning', customDelay);
  }

  info(msg = '', code = null, customDelay = null) {
    return this.add(msg, code, 'info', customDelay);
  }

  danger(msg = '', code = null, customDelay = null) {
    return this.add(msg, code, 'danger', customDelay);
  }

  _createAlert(msg = '', errorCode = null, type = 'danger', resolve) {
    const alert = {
      type,
      msg: this.$sce.trustAsHtml(this.$sanitize(msg.toString())),
      close: () => {
        this.closeAlert(alert);
        resolve();
      },
    };
    if (errorCode) {
      alert.errorCode = errorCode;
    }
    return alert;
  }

  closeAlert(alert) {
    this.$rootScope.alerts = this.$rootScope.alerts.filter((a) => a !== alert);
  }

  clear() {
    this.$rootScope.alerts = [];
  }

  setAutoClose(alert, resolve, delay) {
    this.$timeout(() => {
      alert.close();
      resolve();
    }, delay);
  }
}
